import { render, staticRenderFns } from "./MedicalEDMDataTable.vue?vue&type=template&id=855d7b1c&scoped=true"
import script from "./MedicalEDMDataTable.vue?vue&type=script&lang=js"
export * from "./MedicalEDMDataTable.vue?vue&type=script&lang=js"
import style0 from "./MedicalEDMDataTable.vue?vue&type=style&index=0&id=855d7b1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "855d7b1c",
  null
  
)

export default component.exports